// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8f5518ce","383":"2da7f173","435":"f58968c5","453":"34d7e377","546":"f45f4aab"}[chunkId] + ".chunk.js";
};